(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Backend-Section"] && !Shopify.designMode) return;
  try {
    



(() => {
  if (!window.customElements || !window.AbortController || !window.ResizeObserver) return;
  if (customElements.get('pc-v9-setup') && customElements.get('pc-v9-designer')) return;
  const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const round = n => Math.round(n * 1000) / 1000;
  const parse = (node, fallback = null) => { try { return JSON.parse(node?.textContent || 'null') ?? fallback; } catch { return fallback; } };
  const safeImage = source => {
    if (typeof source !== 'string') return '';
    try { const url = new URL(source, location.origin); return url.protocol === 'https:' || (url.protocol === 'http:' && url.origin === location.origin) ? url.href : ''; } catch { return ''; }
  };
  const legacyNormalize = (raw, product) => {
    if (!raw || raw.version !== 1 || !Array.isArray(raw.views) || !raw.views.length || raw.views.length > 12) throw new Error('invalid_config');
    if (String(raw.productId) !== String(product.id) || raw.handle !== product.handle) throw new Error('wrong_product');
    return {
      version: 1, productId: String(product.id), handle: product.handle, enabled: raw.enabled !== false,
      rules: { move: raw.rules?.move !== false, resize: raw.rules?.resize !== false, rotate: raw.rules?.rotate === true, logo: raw.rules?.logo !== false, text: raw.rules?.text !== false },
      textSettings: {
        maxChars: clamp(Math.floor(number(raw.textSettings?.maxChars, 40)), 1, 150),
        font: ['Arial', 'Georgia', 'Times New Roman', 'Courier New'].includes(raw.textSettings?.font) ? raw.textSettings.font : 'Arial',
        color: /^#[\da-f]{6}$/i.test(raw.textSettings?.color || '') ? raw.textSettings.color : '#18312d',
        allowFont: raw.textSettings?.allowFont !== false, allowColor: raw.textSettings?.allowColor !== false
      },
      views: raw.views.map((v, index) => {
        const image = safeImage(v.image);
        if (!image) throw new Error('invalid_config');
        const width = clamp(number(v.area?.width, 40), 1, 100);
        const height = clamp(number(v.area?.height, 40), 1, 100);
        return {
          id: String(v.id || `view-${index + 1}`).slice(0, 60), name: String(v.name || index + 1).slice(0, 80), image, enabled: v.enabled !== false,
          imageWidth: clamp(number(v.imageWidth, 1000), 1, 20000), imageHeight: clamp(number(v.imageHeight, 1000), 1, 20000),
          area: { shape: v.area?.shape === 'ellipse' ? 'ellipse' : 'rectangle', x: clamp(number(v.area?.x, 30), 0, 100 - width), y: clamp(number(v.area?.y, 30), 0, 100 - height), width, height, physicalWidthMm: clamp(number(v.area?.physicalWidthMm, 20), 1, 1000) },
          logoWidth: clamp(number(v.logoWidth, 50), 1, clamp(number(v.maxLogoWidth, 100), 1, 100)),
          maxLogoWidth: clamp(number(v.maxLogoWidth, 100), 1, 100),
          textWidth: clamp(number(v.textWidth, 60), 1, clamp(number(v.maxTextWidth, 100), 1, 100)),
          maxTextWidth: clamp(number(v.maxTextWidth, 100), 1, 100)
        };
      })
    };
  };
  const areaNormalized = (value, fallback) => {
    const raw = value || fallback, width = clamp(number(raw.width, 40), 1, 100), height = clamp(number(raw.height, 30), 1, 100);
    return { shape: raw.shape === 'ellipse' ? 'ellipse' : 'rectangle', x: clamp(number(raw.x, 25), 0, 100 - width), y: clamp(number(raw.y, 25), 0, 100 - height), width, height, physicalWidthMm: clamp(number(raw.physicalWidthMm, 50), 1, 1000) };
  };
  const normalize = (raw, product) => {
    const result = legacyNormalize(raw, product);
    result.views = result.views.map((view, index) => {
      const source = raw.views[index], settings = source.textSettings || result.textSettings;
      return { ...view, photoNumber: clamp(Math.floor(number(source.photoNumber, index + 1)), 1, 10000),
        types: { logo: typeof source.types?.logo === 'boolean' ? source.types.logo : result.rules.logo, text: typeof source.types?.text === 'boolean' ? source.types.text : result.rules.text },
        separateAreas: source.separateAreas !== false && Boolean(source.areas),
        areas: { logo: areaNormalized(source.areas?.logo, view.area), text: areaNormalized(source.areas?.text, view.area) },
        textSettings: { maxChars: clamp(Math.floor(number(settings.maxChars, 40)), 1, 150), font: ['Arial','Georgia','Times New Roman','Courier New'].includes(settings.font) ? settings.font : 'Arial', color: /^#[\da-f]{6}$/i.test(settings.color || '') ? settings.color : '#17243d', allowFont: settings.allowFont !== false, allowColor: settings.allowColor !== false }
      };
    }); return result;
  };
  const fits = (area, logo, ratio) => {
    const cx = area.x + area.width / 2, cy = area.y + area.height / 2;
    const angle = logo.rotation * Math.PI / 180, sin = Math.sin(angle), cos = Math.cos(angle);
    for (const sx of [-1, 1]) for (const sy of [-1, 1]) {
      const dx = sx * logo.width / 2, dy = sy * logo.height / (2 * ratio);
      const x = logo.x + dx * cos - dy * sin;
      const y = logo.y + (dx * sin + dy * cos) * ratio;
      if (area.shape === 'ellipse') {
        if (((x - cx) / (area.width / 2)) ** 2 + ((y - cy) / (area.height / 2)) ** 2 > 1.000001) return false;
      } else if (x < area.x - .000001 || x > area.x + area.width + .000001 || y < area.y - .000001 || y > area.y + area.height + .000001) return false;
    }
    return true;
  };
  const constrain = (area, candidate, ratio) => {
    const center = { ...candidate, x: area.x + area.width / 2, y: area.y + area.height / 2 };
    for (let i = 0; i < 140 && !fits(area, center, ratio); i++) { center.width *= .95; center.height *= .95; }
    let result = { ...center, x: candidate.x, y: candidate.y };
    if (!fits(area, result, ratio)) {
      let lo = 0, hi = 1;
      for (let i = 0; i < 32; i++) {
        const t = (lo + hi) / 2;
        result = { ...center, x: center.x + (candidate.x - center.x) * t, y: center.y + (candidate.y - center.y) * t };
        if (fits(area, result, ratio)) lo = t; else hi = t;
      }
      result = { ...center, x: center.x + (candidate.x - center.x) * lo, y: center.y + (candidate.y - center.y) * lo };
    }
    return result;
  };


  class Base extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.connectObserver) return;
      const connect = () => {
        if (!this.isConnected || !['[data-labels]', '[data-product]', '[data-config]'].every(selector => this.querySelector(selector)?.textContent.trim())) return;
        this.connectObserver?.disconnect(); this.connectObserver = null; this.initialize();
      };
      this.connectObserver = new MutationObserver(connect);
      this.connectObserver.observe(this, { childList: true, subtree: true, characterData: true });
      connect();
    }
    initialize() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.labels = parse(this.querySelector('[data-labels]'), {});
      this.product = parse(this.querySelector('[data-product]'));
      this.config = parse(this.querySelector('[data-config]'));
      this.stage = this.querySelector('[data-artboard]');
      this.image = this.querySelector('[data-product-image]');
      this.areaElement = this.querySelector('[data-area]');
      this.logoElement = this.querySelector('[data-logo]');
      this.textElement = this.querySelector('[data-text-layer]');
      this.viewIndex = 0;
      this.on(this.image, 'load', () => this.imageLoaded());
      this.on(this.image, 'error', () => this.status('image_error', true));
      try {
        this.init();
        if (this.stage) { this.observer = new ResizeObserver(() => this.render()); this.observer.observe(this.stage); }
      } catch {
        this.config = null;
        const submit = this.$('[data-submit]'); if (submit) submit.disabled = true;
        this.on(this.$('form'), 'submit', event => event.preventDefault());
        this.status('initialization_error', true);
      }
    }
    disconnectedCallback() {
      this.connectObserver?.disconnect(); this.connectObserver = null;
      this.abort?.abort(); this.searchAbort?.abort(); clearTimeout(this.searchTimer);
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.ready = false;
      this.observer?.disconnect();
    }
    $(selector) { return this.querySelector(selector); }
    on(node, event, fn) { node?.addEventListener(event, fn, { signal: this.abort.signal }); }
    t(key) { return this.labels[key] || key; }
    status(key, error = false) {
      const node = this.$('[data-status]');
      if (node) { node.textContent = this.t(key); node.dataset.error = String(error); }
    }
    view() { return this.config?.views?.[this.viewIndex]; }
    areaFor(kind) { return this.view()?.areas?.[kind] || this.view()?.area; }
    allowed(kind) { return this.config?.rules?.[kind] !== false && this.view()?.types?.[kind] !== false; }
    textSettingsFor() { return this.view()?.textSettings || this.config?.textSettings; }
    imageLoaded() {
      const v = this.view();
      if (v && this.image.naturalWidth) { v.imageWidth = this.image.naturalWidth; v.imageHeight = this.image.naturalHeight; }
      this.render();
    }
    render() {
      const v = this.view();
      if (!v) return;
      const a = v.area;
      this.logoElement.hidden = !this.logo || this.config.rules.logo === false;
      Object.assign(this.areaElement.style, { left: `${a.x}%`, top: `${a.y}%`, width: `${a.width}%`, height: `${a.height}%` });
      this.areaElement.dataset.shape = a.shape;
      if (this.logo) {
        Object.assign(this.logoElement.style, { left: `${this.logo.x}%`, top: `${this.logo.y}%`, width: `${this.logo.width}%`, height: `${this.logo.height}%`, '--cc-rotation': `${this.logo.rotation}deg` });
      }
      if (this.textState && this.textElement) {
        Object.assign(this.textElement.style, { left: `${this.textState.x}%`, top: `${this.textState.y}%`, width: `${this.textState.width}%`, height: `${this.textState.height}%`, '--cc-rotation': `${this.textState.rotation}deg` });
        const span = this.textElement.querySelector('span');
        span.style.fontSize = `${this.textState.width * this.stage.clientWidth / this.textMeasure}px`;
        span.style.fontFamily = this.textFont; span.style.color = this.textColor;
      }
    }
    renderTabs() {
      const container = this.$('[data-tabs]');
      container.replaceChildren();
      this.config.views.forEach((v, index) => {
        const b = document.createElement('button'); b.type = 'button'; b.textContent = v.name; b.setAttribute('aria-pressed', String(index === this.viewIndex));
        b.addEventListener('click', () => this.selectView(index)); container.append(b);
      });
    }
    async upload(input) {
      const file = input.files?.[0];
      if (!file) { this.logo = null; this.logoRatio = null; this.logoElement.hidden = true; return false; }
      if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
        input.value = ''; this.logo = null; this.logoRatio = null; this.logoElement.hidden = true; this.status('file_error', true); return false;
      }
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = URL.createObjectURL(file);
      const src = this.objectUrl;
      try {
        const img = new Image(); img.src = src; await img.decode();
        if (src !== this.objectUrl || !this.isConnected) return false;
        this.logoRatio = img.width / img.height;
        this.logoElement.src = src; this.logoElement.hidden = false;
        this.resetLogo(); this.status('logo_loaded'); return true;
      } catch { input.value = ''; this.logo = null; this.logoRatio = null; this.logoElement.hidden = true; this.status('file_error', true); return false; }
    }
    resetLogo() {
      const v = this.view(); if (!v || !this.logoRatio) return; if (!this.allowed('logo')) { this.logo = null; this.logoElement.hidden = true; return; } const area = this.areaFor('logo');
      const width = area.width * v.logoWidth / 100;
      this.logo = constrain(area, { x: area.x + area.width / 2, y: area.y + area.height * (v.separateAreas ? .5 : this.textState ? .35 : .5), width, height: width * v.imageWidth / v.imageHeight / this.logoRatio, rotation: 0 }, v.imageWidth / v.imageHeight);
      this.render();
    }
    drawText(value, widthPercent, rotation = 0, previous = null) {
      const v = this.view(); if (!v || !this.textElement) return; const area = this.areaFor('text');
      const text = String(value).slice(0, this.textSettingsFor().maxChars).trim();
      this.textValue = text; this.textElement.hidden = !text;
      if (!text) { this.textState = null; this.render(); return; }
      this.measureContext ||= document.createElement('canvas').getContext('2d');
      this.measureContext.font = `600 100px "${this.textFont}"`;
      this.textMeasure = Math.max(1, this.measureContext.measureText(text).width);
      const width = area.width * clamp(number(widthPercent, v.textWidth), 1, v.maxTextWidth) / 100;
      this.textState = constrain(area, { x: previous?.x ?? area.x + area.width / 2, y: previous?.y ?? area.y + area.height * (v.separateAreas ? .5 : this.logo ? .75 : .5), width, height: width * 1.2 * 100 / this.textMeasure * v.imageWidth / v.imageHeight, rotation }, v.imageWidth / v.imageHeight);
      this.textElement.querySelector('span').textContent = text;
      this.textElement.setAttribute('aria-label', `${this.t('custom_text')}: ${text}`);
      this.render();
    }
    pointer(node, start, update, finish) {
      this.on(node, 'pointerdown', event => {
        if (event.button !== 0 || !this.view()) return;
        const info = start(event); if (!info) return;
        event.preventDefault(); node.setPointerCapture(event.pointerId);
        const box = this.stage.getBoundingClientRect(), x = event.clientX, y = event.clientY;
        const move = e => update(info, (e.clientX - x) / box.width * 100, (e.clientY - y) / box.height * 100);
        const end = e => {
          if (e.pointerId !== event.pointerId) return;
          node.removeEventListener('pointermove', move); node.removeEventListener('pointerup', end); node.removeEventListener('pointercancel', end);
          if (node.hasPointerCapture(e.pointerId)) node.releasePointerCapture(e.pointerId);
          finish?.();
        };
        node.addEventListener('pointermove', move, { signal: this.abort.signal });
        node.addEventListener('pointerup', end, { signal: this.abort.signal });
        node.addEventListener('pointercancel', end, { signal: this.abort.signal });
      });
    }
  }

  class Setup extends Base {
    init() {
      this.ui = { ...parse(this.$('[data-wizard-ui]'), {}), ...parse(this.$('[data-catalog-ui]'), {}) };
      this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
      this.sidebarProduct = this.product; this.sidebarConfig = this.config;
      this.activeKind = 'logo'; this.step = 1; this.sampleText = this.w("Your text");
      this.on(this.$('[data-find-product]'), 'click', e => { e.preventDefault(); e.stopPropagation(); this.search(); });
      this.on(this.$('[data-search]'), 'keydown', e => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); this.search(); } });
      this.on(this.$('[data-search]'), 'input', () => { this.searchAbort?.abort(); this.catalogAbort?.abort(); clearTimeout(this.searchTimer); this.searchTimer = setTimeout(() => this.search(), 450); });
      this.on(this.$('[data-load-handle]'), 'click', e => { e.preventDefault(); e.stopPropagation(); this.byHandle(); });
      this.on(this.$('[data-handle]'), 'keydown', e => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); this.byHandle(); } });
      this.on(this.$('[data-load-sidebar]'), 'click', () => this.loadSidebar());
      this.on(this.$('[data-back]'), 'click', () => this.go(this.step - 1));
      this.on(this.$('[data-next]'), 'click', () => this.go(this.step + 1));
      this.on(this.$('[data-change-product]'), 'click', () => this.go(1));
      this.on(this.$('[data-copy]'), 'click', () => this.copy());
      this.on(this.$('[data-save-draft]'), 'click', () => this.saveDraft());
      this.on(this.$('[data-import]'), 'click', () => this.import());
      this.on(this.$('[data-sample-file]'), 'change', async e => { const loaded = await this.upload(e.target); if (!loaded) { if (this.objectUrl) URL.revokeObjectURL(this.objectUrl); this.objectUrl = null; } this.updatePreview(); });
      this.on(this.$('[data-sample-text]'), 'input', e => { this.sampleText = e.target.value; this.updatePreview(); });
      this.querySelectorAll('[data-edit-kind]').forEach(button => this.on(button, 'click', () => { this.activeKind = button.dataset.editKind; this.syncEditor(); }));
      this.querySelectorAll('[data-area-field]').forEach(input => this.on(input, 'input', () => this.editArea()));
      this.querySelectorAll('[data-text-setting]').forEach(input => this.on(input, 'input', () => {
        const v = this.view(); if (!v) return;
        v.textSettings[input.dataset.textSetting] = input.type === 'number' ? clamp(number(input.value, 40), 1, 150) : input.value;
        this.updatePreview();
      }));
      for (const kind of ['logo', 'text']) {
        const guide = this.$('[data-guide="' + kind + '"]');
        this.pointer(guide, event => event.target.closest('[data-guide-resizer]') || this.activeKind !== kind ? null : { ...this.areaFor(kind) }, (old, dx, dy) => {
          Object.assign(this.areaFor(kind), { x: clamp(old.x + dx, 0, 100 - old.width), y: clamp(old.y + dy, 0, 100 - old.height) }); this.areaChanged();
        });
        this.pointer(guide.querySelector('[data-guide-resizer]'), () => this.activeKind === kind ? { ...this.areaFor(kind) } : null, (old, dx, dy) => {
          Object.assign(this.areaFor(kind), { width: clamp(old.width + dx, 1, 100 - old.x), height: clamp(old.height + dy, 1, 100 - old.y) }); this.areaChanged();
        });
      }
      this.loadDrafts();
      this.product = null; this.config = null; this.initCatalog(); this.go(1);
      this.$("[data-find-product]").disabled = false; this.$("[data-load-handle]").disabled = false; this.dataset.initialized = "true";
    }
    selected() { return this.config?.views.filter(v => v.enabled !== false) || []; }
    defaultView(image, index) {
      const logo = { shape: 'rectangle', x: 30, y: 25, width: 40, height: 30, physicalWidthMm: 50 };
      const text = { shape: 'rectangle', x: 25, y: 65, width: 50, height: 14, physicalWidthMm: 60 };
      return { id: 'photo-' + (index + 1), name: this.w("Photo ") + (index + 1), photoNumber: index + 1, enabled: true, image, imageWidth: 1000, imageHeight: 1000, types: { logo: false, text: false }, separateAreas: true, areas: { logo, text }, area: { ...logo }, textSettings: { maxChars: 40, font: 'Arial', color: '#17243d', allowFont: true, allowColor: true }, logoWidth: 70, maxLogoWidth: 100, textWidth: 80, maxTextWidth: 100 };
    }
    defaultConfig(product) {
      return { version: 1, productId: String(product.id), handle: product.handle, enabled: true, rules: { move: false, resize: true, rotate: false, logo: true, text: true }, textSettings: { maxChars: 40, font: 'Arial', color: '#17243d', allowFont: true, allowColor: true }, views: [] };
    }
    productImages() { return (this.product?.images || []).map(image => safeImage(typeof image === 'string' ? image : image.src || image.url)).filter(Boolean); }
    setProduct(product, config = null) {
      try {
        if (!product?.id || !product.handle) throw new Error('invalid_config');
        const next = config ? normalize(config, product) : this.defaultConfig(product);
        this.productAbort?.abort(); this.product = product; this.config = next; this.logo = null; this.logoRatio = null; this.textState = null;
        if (!this.productImages().length) throw new Error('no_images');
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl); this.objectUrl = null;
        this.$('[data-sample-file]').value = ''; this.$('[data-results]').replaceChildren();
        for (const view of this.config.views) {
          view.photoNumber = Math.max(1, this.productImages().indexOf(view.image) + 1);
          view.types ||= { logo: this.config.rules.logo, text: this.config.rules.text };
          view.areas ||= { logo: { ...view.area }, text: { ...view.area } };
          view.textSettings ||= { ...this.config.textSettings };
        }
        this.$('[data-product-title]').textContent = product.title;
        this.$('[data-product-summary]').hidden = false;
        this.$('[data-product-admin]').href = new URL(encodeURIComponent(product.id), this.dataset.adminRoot).href;
        this.renderPhotos(); this.go(2);
      } catch (error) { this.status(error.message in this.labels ? error.message : 'invalid_config', true); }
    }
    renderPhotos() {
      const grid = this.$('[data-photo-grid]'); grid.replaceChildren();
      this.productImages().forEach((src, index) => {
        const selected = this.selected().some(v => v.image === src);
        const button = document.createElement('button'); button.type = 'button'; button.className = 'pw-photo'; button.setAttribute('aria-pressed', String(selected)); button.setAttribute('aria-label', this.w("Select photo ") + (index + 1));
        const img = document.createElement('img'); img.src = src; img.alt = ''; img.width = 240; img.height = 200; img.loading = 'lazy';
        const label = document.createElement('strong'); label.textContent = this.w("Photo ") + (index + 1);
        const state = document.createElement('span'); state.textContent = selected ? this.w("✓ Selected for customization") : this.w("Select this photo");
        button.append(img, label, state); button.addEventListener('click', () => this.togglePhoto(src, index)); grid.append(button);
      });
      this.$('[data-selection-count]').textContent = this.selected().length + this.w(" photos selected"); this.updateNext();
    }
    togglePhoto(src, index) {
      const existing = this.config.views.find(v => v.image === src);
      if (existing?.enabled !== false && existing) existing.enabled = false;
      else {
        if (this.selected().length >= 12) { this.status('manager_limit_images', true); return; }
        if (existing) existing.enabled = true;
        else { this.config.views = this.config.views.filter(v => v.enabled !== false); this.config.views.push(this.defaultView(src, index)); }
      }
      this.renderPhotos();
    }
    renderChoices() {
      const list = this.$('[data-type-choices]'); list.replaceChildren();
      for (const view of this.selected()) {
        const card = document.createElement('div'); card.className = 'pw-type-card';
        const img = document.createElement('img'); img.src = view.image; img.alt = ''; img.width = 160; img.height = 120;
        const body = document.createElement('div'), heading = document.createElement('h3'); heading.textContent = this.w("Photo ") + view.photoNumber;
        const help = document.createElement('p'); help.textContent = this.w("Choose one or both. Each gets its own placement area."); body.append(heading, help);
        const choices = document.createElement('div'); choices.className = 'pw-type-options';
        for (const kind of ['logo', 'text']) {
          const label = document.createElement('label'), input = document.createElement('input'); input.type = 'checkbox'; input.checked = view.types[kind]; input.setAttribute('aria-label', (kind === 'logo' ? this.w("Logo") : this.w("Text")) + this.w(" on photo ") + view.photoNumber);
          input.addEventListener('change', () => { view.types[kind] = input.checked; this.updateNext(); });
          label.append(input, document.createTextNode(kind === 'logo' ? this.w("Logo customization") : this.w("Text customization"))); choices.append(label);
        }
        body.append(choices); card.append(img, body); list.append(card);
      }
    }
    go(step) {
      step = clamp(step, 1, 5);
      if (step > 1 && !this.product) return;
      if (step > 2 && !this.selected().length) return;
      if (step > 3 && this.selected().some(v => !v.types.logo && !v.types.text)) return;
      this.step = step;
      this.$('[data-status]').hidden = true;
      this.$('[data-product-summary]').hidden = step === 1 || !this.product;
      if (step === 1 && this.catalog) this.showCatalog(this.catalog, this.catalogQuery, this.catalogPartial);
      this.querySelectorAll('[data-step-panel]').forEach(panel => { panel.hidden = Number(panel.dataset.stepPanel) !== step; });
      this.querySelectorAll('[data-step-indicator]').forEach(node => { node.dataset.state = Number(node.dataset.stepIndicator) === step ? 'active' : Number(node.dataset.stepIndicator) < step ? 'done' : 'pending'; node.setAttribute('aria-current', Number(node.dataset.stepIndicator) === step ? 'step' : 'false'); });
      this.$('[data-back]').hidden = step === 1;
      this.$('[data-next]').hidden = step === 1 || step === 5;
      this.$('[data-next]').textContent = step === 2 ? this.w("Next: choose Logo / Text") : step === 3 ? this.w("Next: mark placement areas") : this.w("Next: review setup");
      this.$('[data-step-note]').textContent = this.w("Step ") + step + this.w(" of 5");
      if (step === 2) this.renderPhotos();
      if (step === 3) this.renderChoices();
      if (step === 4) { const current = this.view(); this.selectView(current?.enabled !== false && current && this.config.views.indexOf(current) >= 0 ? this.config.views.indexOf(current) : this.config.views.indexOf(this.selected()[0])); }
      if (step === 5) this.renderReview();
      this.updateNext();
    }
    updateNext() { const next = this.$('[data-next]'); if (next) next.disabled = this.step === 2 ? !this.selected().length : this.step === 3 ? this.selected().some(v => !v.types.logo && !v.types.text) : false; }
    w(text) { return this.ui?.[text] || text; }
    status(key, error = false) { super.status(key, error); const node = this.$('[data-status]'); if (node) node.hidden = false; }
    selectView(index) {
      this.viewIndex = index; const view = this.view(); if (!view) return;
      if (!view.types[this.activeKind]) this.activeKind = view.types.logo ? 'logo' : 'text';
      this.image.width = view.imageWidth; this.image.height = view.imageHeight; this.image.src = view.image;
      this.$('[data-view-title]').textContent = this.w("Photo ") + view.photoNumber;
      const strip = this.$('[data-edit-photos]'); strip.replaceChildren();
      for (const candidate of this.selected()) {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = this.w("Photo ") + candidate.photoNumber; button.setAttribute('aria-pressed', String(candidate === view));
        button.addEventListener('click', () => this.selectView(this.config.views.indexOf(candidate))); strip.append(button);
      }
      this.syncEditor();
    }
    syncEditor() {
      const view = this.view(); if (!view) return;
      const kind = this.activeKind, area = this.areaFor(kind), title = kind === 'logo' ? this.w("Logo") : this.w("Text");
      this.querySelectorAll('[data-edit-kind]').forEach(button => { button.hidden = !view.types[button.dataset.editKind]; button.setAttribute('aria-pressed', String(button.dataset.editKind === kind)); });
      this.$('[data-area-title]').textContent = title + this.w(" placement area");
      this.$('[data-edit-instruction]').textContent = this.w("Drag the ") + (kind === 'logo' ? this.w("blue") : this.w("purple")) + this.w(" box to choose where the ") + kind + this.w(" goes. Drag its corner to resize.");
      this.$('[data-sample-logo-group]').hidden = kind !== 'logo'; this.$('[data-sample-text-group]').hidden = kind !== 'text';
      this.querySelectorAll('[data-area-field]').forEach(input => {
        const key = input.dataset.areaField;
        input.value = key === 'start' ? round(view[kind + 'Width'] / 100 * area.physicalWidthMm) : key === 'max' ? round(view[kind === 'logo' ? 'maxLogoWidth' : 'maxTextWidth'] / 100 * area.physicalWidthMm) : area[key];
      });
      this.$('[data-sample-text]').value = this.sampleText;
      this.querySelectorAll('[data-text-setting]').forEach(input => { input.value = view.textSettings[input.dataset.textSetting]; });
      this.updatePreview();
    }
    editArea() {
      const view = this.view(), kind = this.activeKind; if (!view) return;
      const area = this.areaFor(kind), values = {};
      this.querySelectorAll('[data-area-field]').forEach(input => { values[input.dataset.areaField] = input.value; });
      area.shape = values.shape === 'ellipse' ? 'ellipse' : 'rectangle';
      area.width = clamp(number(values.width, area.width), 1, 100); area.height = clamp(number(values.height, area.height), 1, 100);
      area.x = clamp(number(values.x, area.x), 0, 100 - area.width); area.y = clamp(number(values.y, area.y), 0, 100 - area.height);
      area.physicalWidthMm = clamp(number(values.physicalWidthMm, 50), 1, 1000);
      view[kind === 'logo' ? 'maxLogoWidth' : 'maxTextWidth'] = clamp(number(values.max, area.physicalWidthMm) / area.physicalWidthMm * 100, 1, 100);
      view[kind + 'Width'] = clamp(number(values.start, area.physicalWidthMm * .7) / area.physicalWidthMm * 100, 1, view[kind === 'logo' ? 'maxLogoWidth' : 'maxTextWidth']);
      view.area = { ...(view.types.logo ? view.areas.logo : view.areas.text) }; this.updatePreview();
    }
    areaChanged() {
      const area = this.areaFor(this.activeKind);
      for (const key of ['x', 'y', 'width', 'height']) this.$('[data-area-field="' + key + '"]').value = round(area[key]);
      this.view().area = { ...(this.view().types.logo ? this.view().areas.logo : this.view().areas.text) }; this.updatePreview();
    }
    updatePreview() {
      const view = this.view(); if (!view || this.step !== 4) return;
      this.stage.style.maxWidth = Math.min(640, 380 * view.imageWidth / view.imageHeight) + 'px';
      if (!this.objectUrl) {
        this.logoElement.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="320" height="160" viewBox="0 0 320 160"><rect x="3" y="3" width="314" height="154" rx="18" fill="#eff6ff" stroke="#2563eb" stroke-width="6"/><text x="160" y="99" text-anchor="middle" font-family="Arial" font-weight="700" font-size="57" fill="#2563eb">LOGO</text></svg>'); this.logoRatio = 2;
      }
      this.textFont = view.textSettings.font; this.textColor = view.textSettings.color;
      this.drawText(view.types.text ? this.sampleText : '', view.textWidth);
      if (view.types.logo) this.resetLogo(); else this.logo = null;
      this.render();
    }
    imageLoaded() { super.imageLoaded(); this.updatePreview(); }
    render() {
      const view = this.view(); if (!view || this.step !== 4) return;
      for (const kind of ['logo', 'text']) {
        const guide = this.$('[data-guide="' + kind + '"]'), area = this.areaFor(kind); guide.hidden = !view.types[kind];
        Object.assign(guide.style, { left: area.x + '%', top: area.y + '%', width: area.width + '%', height: area.height + '%' }); guide.dataset.shape = area.shape; guide.dataset.active = String(this.activeKind === kind);
      }
      this.logoElement.hidden = !view.types.logo || !this.logo;
      if (this.logo) Object.assign(this.logoElement.style, { left: this.logo.x + '%', top: this.logo.y + '%', width: this.logo.width + '%', height: this.logo.height + '%' });
      this.textElement.hidden = !view.types.text || !this.textState;
      if (this.textState) {
        Object.assign(this.textElement.style, { left: this.textState.x + '%', top: this.textState.y + '%', width: this.textState.width + '%', height: this.textState.height + '%' });
        Object.assign(this.textElement.querySelector('span').style, { fontFamily: this.textFont, color: this.textColor, fontSize: this.textState.width * this.stage.clientWidth / this.textMeasure + 'px' });
      }
      const area = this.areaFor(this.activeKind);
      this.$('[data-area-size]').textContent = round(area.physicalWidthMm) + ' × ' + round(area.physicalWidthMm * area.height / area.width * view.imageHeight / view.imageWidth) + ' mm';
    }
    exportConfig() {
      const selected = this.selected();
      const config = structuredClone(this.config); config.views = structuredClone(selected);
      config.rules.logo = selected.some(v => v.types.logo); config.rules.text = selected.some(v => v.types.text);
      for (const view of config.views) view.area = { ...(view.types.logo ? view.areas.logo : view.areas.text) };
      return normalize(config, this.product);
    }
    renderReview() {
      const config = this.exportConfig(); this.$('[data-output]').value = JSON.stringify(config, null, 2);
      const list = this.$('[data-review-list]'); list.replaceChildren();
      for (const view of config.views) {
        const row = document.createElement('div'); row.className = 'pw-review-row'; const image = document.createElement('img'); image.src = view.image; image.alt = ''; image.width = 90; image.height = 75;
        const body = document.createElement('div'), title = document.createElement('strong'); title.textContent = this.w("Photo ") + view.photoNumber; body.append(title);
        for (const kind of ['logo', 'text']) if (view.types[kind]) { const p = document.createElement('p'); p.textContent = (kind === 'logo' ? this.w("Logo") : this.w("Text")) + this.w(" · separate area · ") + round(view.areas[kind].physicalWidthMm) + this.w(" mm wide"); body.append(p); }
        const edit = document.createElement('button'); edit.type = 'button'; edit.textContent = this.w("Edit photo ") + view.photoNumber; edit.addEventListener('click', () => { this.viewIndex = this.config.views.findIndex(v => v.id === view.id); this.go(4); }); row.append(image, body, edit); list.append(row);
      }
    }
    loadDrafts() {
      try { this.drafts = JSON.parse(localStorage.getItem('pc-v1-drafts:' + location.host) || '{}'); } catch { this.drafts = {}; }
      if (!this.drafts || typeof this.drafts !== 'object' || Array.isArray(this.drafts)) this.drafts = {};
    }
    saveDraft() { try { this.drafts[String(this.product.id)] = { product: this.product, config: this.exportConfig() }; localStorage.setItem('pc-v1-drafts:' + location.host, JSON.stringify(this.drafts)); this.status('draft_saved'); } catch { this.status('storage_error', true); } }
    async copy() {
      this.renderReview();
      try { await navigator.clipboard.writeText(this.$('[data-output]').value); this.status('copied'); }
      catch { this.$('[data-manual-code]').open = true; this.$('[data-output]').focus(); this.$('[data-output]').select(); this.status('copy_manual'); }
    }
    import() { try { this.setProduct(this.product, JSON.parse(this.$('[data-output]').value)); this.status('imported'); } catch { this.status('invalid_config', true); } }
    loadSidebar() {
      this.searchAbort?.abort(); clearTimeout(this.searchTimer);
      const product = this.sidebarProduct;
      if (product && typeof product === 'object' && product.id && Array.isArray(product.images)) {
        this.setProduct(product, this.sidebarConfig);
      } else if (typeof product === 'string' && /^[a-zA-Z0-9_-]+$/.test(product)) {
        this.loadProduct(product);
      } else { this.status('sidebar_missing', true); }
    }
    resourceUrl(path, parameters = {}) {
      const url = new URL(this.root + path, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      for (const [key, value] of Object.entries(parameters)) url.searchParams.set(key, value);
      return url;
    }
    async jsonResponse(url, signal) {
      const response = await fetch(String(url), { signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      try { return await response.json(); } catch { throw new Error('non-JSON response'); }
    }
    async sectionResponse(path, marker, signal, parameters = {}) {
      if (!this.dataset.sectionId) throw new Error('section ID missing');
      const url = this.resourceUrl(path, { ...parameters, section_id: this.dataset.sectionId });
      const response = await fetch(String(url), { signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = doc.querySelector(marker);
      if (!node) throw new Error('section data missing');
      return JSON.parse(node.textContent);
    }
    showProducts(products) {
      const results = this.$('[data-results]'); results.replaceChildren();
      for (const product of products) {
        if (!product?.handle || !product.title) continue;
        const button = document.createElement('button'); button.type = 'button'; button.className = 'cc-result';
        const image = product.image;
        const src = safeImage(typeof image === 'string' ? image : image?.url || image?.src || product.featured_image?.url);
        if (src) { const img = document.createElement('img'); img.src = src; img.alt = ''; img.width = 42; img.height = 42; button.append(img); }
        const text = document.createElement('span'), title = document.createElement('strong'); title.textContent = product.title;
        text.append(title, document.createTextNode(product.handle)); button.append(text);
        button.addEventListener('click', () => this.loadProduct(product.handle)); results.append(button);
      }
    }
    initCatalog() {
      const seed = parse(this.$('[data-pc-catalog]'), { products: [], page: 1, pages: 1, total: 0 });
      this.catalogCache = new Map(); this.catalogQuery = ''; this.catalog = seed;
      this.catalogCache.set('|' + seed.page, seed);
      this.on(this.$('[data-show-all]'), 'click', () => this.showAllProducts());
      this.on(this.$('[data-catalog-prev]'), 'click', () => this.fetchCatalog(this.catalog.page - 1, this.catalogQuery));
      this.on(this.$('[data-catalog-next]'), 'click', () => this.fetchCatalog(this.catalog.page + 1, this.catalogQuery));
      this.on(this.$('[data-catalog-retry]'), 'click', () => this.fetchCatalog(1, this.$('[data-search]').value.trim(), true));
      this.showCatalog(seed);
    }
    showCatalog(data, query = '', partial = false) {
      if (!Array.isArray(data?.products)) throw new Error('catalog data missing');
      this.catalog = data; this.catalogQuery = query; this.catalogPartial = partial;
      const grid = this.$('[data-results]'); grid.replaceChildren();
      for (const entry of data.products) {
        const product = entry.product; if (!product?.id || !product.handle) continue;
        const card = document.createElement('button'); card.type = 'button'; card.className = 'pc-catalog-card'; card.dataset.productHandle = product.handle;
        card.setAttribute('aria-label', this.w('Set up ') + product.title);
        const src = safeImage(entry.image || product.images?.[0]);
        if (src) { const img = document.createElement('img'); img.src = src; img.alt = ''; img.width = 320; img.height = 220; img.loading = 'lazy'; card.append(img); }
        else { const placeholder = document.createElement('span'); placeholder.className = 'pc-catalog-placeholder'; placeholder.textContent = this.w('No product image'); card.append(placeholder); }
        const body = document.createElement('span'); body.className = 'pc-catalog-body';
        const title = document.createElement('strong'); title.textContent = product.title;
        const skus = [...new Set((product.variants || []).map(v => v.sku).filter(Boolean))];
        const sku = document.createElement('span'); sku.className = 'pc-catalog-skus'; sku.textContent = skus.length ? this.w('SKU: ') + skus.slice(0, 3).join(' · ') + (skus.length > 3 ? ' +' + (skus.length - 3) : '') : this.w('No SKU assigned');
        const state = document.createElement('span'); state.className = 'pc-catalog-state'; state.textContent = entry.configuration?.views?.length ? this.w('Setup saved') : this.w('Not set up');
        const action = document.createElement('span'); action.className = 'pc-catalog-action'; action.textContent = this.w('Choose product →');
        body.append(title, sku, state, action); card.append(body);
        card.addEventListener('click', () => {
          this.catalogAbort?.abort(); this.searchAbort?.abort(); clearTimeout(this.searchTimer);
          this.setProduct(product, entry.configuration || this.drafts?.[String(product.id)]?.config);
        }); grid.append(card);
      }
      this.$('[data-catalog-count]').textContent = partial ? this.w('Search incomplete · matches so far: ') + data.total : query ? data.total + this.w(' matching products') : data.total + this.w(' products in your Online Store catalog');
      this.$('[data-catalog-page]').textContent = this.w('Page ') + data.page + this.w(' of ') + Math.max(1, data.pages);
      this.$('[data-catalog-prev]').disabled = partial || data.page <= 1;
      this.$('[data-catalog-next]').disabled = partial || data.page >= data.pages;
      this.$('[data-catalog-empty]').hidden = data.products.length > 0;
      this.$('[data-catalog-pagination]').hidden = !data.products.length;
      this.$('[data-show-all]').hidden = !query;
      this.$('[data-catalog-empty] h4').textContent = partial ? this.w('Search is not complete') : query ? this.w('No matching products') : this.w('No products to show');
      this.$('[data-catalog-empty] p').textContent = partial ? this.w('Some catalog pages could not be loaded. Retry the search to check the remaining products.') : query ? this.w('Every catalog page has been checked. Try part of the product title or check the SKU.') : this.w('Products must be published to the Online Store and included in the All collection.');
    }
    async catalogPage(page, signal, refresh = false) {
      const key = '|' + page;
      if (!refresh && this.catalogCache.has(key)) return this.catalogCache.get(key);
      // Keep the manager page context and its theme preview. Cross-template
      // section requests can fail even when the initial catalog is visible.
      const current = new URL(location.href);
      const url = new URL(current.pathname, current.origin);
      for (const name of ['preview_theme_id', 'view']) if (current.searchParams.has(name)) url.searchParams.set(name, current.searchParams.get(name));
      url.searchParams.set(this.catalogCache.get('|1')?.pageParameter || 'page', String(page));
      let lastError;
      for (const sectionOnly of [true, false]) {
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const target = new URL(url);
        if (sectionOnly) target.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(String(target), { signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const node = doc.querySelector('[data-pc-catalog]');
          if (!node) throw new Error('catalog data missing');
          const data = JSON.parse(node.textContent);
          if (!Array.isArray(data.products) || data.page !== page || !Number.isFinite(data.pages) || !Number.isFinite(data.total)) throw new Error('catalog page did not load');
          if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
          this.catalogCache.set(key, data); return data;
        } catch (error) { if (signal.aborted || error.name === 'AbortError') throw error; lastError = error; }
      }
      throw lastError;
    }
    catalogMatches(entry, query) {
      const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/&/g, ' and ').replace(/[^\p{L}\p{N}]+/gu, ' ').trim().replace(/\s+/g, ' ');
      const needle = normalize(query); if (!needle) return false;
      const title = normalize(entry.product.title);
      const words = needle.split(' ');
      if (title.includes(needle) || words.every(word => title.includes(word))) return true;
      const compact = needle.replace(/ /g, '');
      return (entry.product.variants || []).some(variant => normalize(variant.sku).replace(/ /g, '').includes(compact));
    }
    catalogSearchData(query, page = 1) {
      const entries = new Map();
      for (const [key, data] of this.catalogCache) if (key.startsWith('|')) for (const entry of data.products) if (this.catalogMatches(entry, query)) entries.set(String(entry.product.id), entry);
      const matches = [...entries.values()];
      return { products: matches.slice((page - 1) * 24, page * 24), page, pages: Math.ceil(matches.length / 24), total: matches.length };
    }
    async searchCatalog(query, page, signal, refresh) {
      // The real store's search endpoint indexes variant SKUs. Use its section
      // response first so a match does not wait for a complete catalog download.
      try {
        const found = await this.sectionResponse('search', '[data-pc-catalog]', signal, { q: query, type: 'product', page: String(page), 'options[prefix]': 'last', 'options[unavailable_products]': 'show' });
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        if (found?.page === page && Number.isFinite(found.total) && Number.isFinite(found.pages) && Array.isArray(found.products) && found.products.length) return found;
      } catch (error) { if (signal.aborted || error.name === 'AbortError') throw error; }
      const first = await this.catalogPage(1, signal, refresh);
      let next = 1, checked = 0;
      const scan = async () => {
        while (next <= Math.max(1, first.pages)) {
          if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
          const number = next++;
          await this.catalogPage(number, signal, refresh && number > 1);
          if (signal.aborted || !this.isConnected || this.step !== 1) return;
          checked++;
          const matches = this.catalogSearchData(query);
          if (matches.total) this.showCatalog(matches, query, true);
          this.$('[data-catalog-count]').textContent = this.w('Searching catalog · pages checked: ') + checked + this.w(' of ') + Math.max(1, first.pages) + this.w(' · matches: ') + matches.total;
        }
      };
      // Keep outstanding storefront requests bounded; allow results to be chosen
      // immediately while the rest of the fallback search is still running.
      const scans = await Promise.allSettled(Array.from({ length: Math.min(4, Math.max(1, first.pages)) }, scan));
      const failed = scans.find(result => result.status === 'rejected');
      if (failed) throw failed.reason;
      if (signal.aborted || !this.isConnected || this.step !== 1) throw new DOMException('Aborted', 'AbortError');
      const data = this.catalogSearchData(query, page);
      for (let resultPage = 1; resultPage <= Math.max(1, data.pages); resultPage++) this.catalogCache.set(query + '|' + resultPage, this.catalogSearchData(query, resultPage));
      return data;
    }
    async fetchCatalog(page = 1, query = '', refresh = false) {
      this.catalogAbort?.abort(); const controller = new AbortController(); this.catalogAbort = controller;
      const key = query + '|' + page;
      if (!refresh && this.catalogCache.has(key)) { this.showCatalog(this.catalogCache.get(key), query); this.$('[data-results]').setAttribute('aria-busy', 'false'); this.$('[data-status]').hidden = true; return; }
      this.$('[data-catalog-count]').textContent = this.w('Loading products…');
      this.$('[data-catalog-prev]').disabled = true; this.$('[data-catalog-next]').disabled = true;
      this.$('[data-results]').setAttribute('aria-busy', 'true');
      if (query) {
        this.$('[data-results]').replaceChildren();
        this.$('[data-catalog-empty]').hidden = true;
        this.$('[data-catalog-pagination]').hidden = true;
      }
      try {
        let data;
        if (query) data = await this.searchCatalog(query, page, controller.signal, refresh);
        else data = await this.catalogPage(Math.max(1, page), controller.signal, refresh);
        if (controller.signal.aborted || !this.isConnected || this.step !== 1) return;
        this.catalogCache.set(key, data); this.showCatalog(data, query); this.$('[data-status]').hidden = true;
      } catch (error) {
        if (error.name === 'AbortError' || controller.signal.aborted || !this.isConnected || this.step !== 1) return;
        if (query) {
          this.showCatalog(this.catalogSearchData(query), query, true);
        } else { this.showCatalog(this.catalog, this.catalogQuery, this.catalogPartial); }
        this.status('catalog_request_error', true);
        this.$('[data-status]').textContent += ' (' + String(error.message).slice(0, 100) + ')';
      } finally { if (this.catalogAbort === controller) this.$('[data-results]').setAttribute('aria-busy', 'false'); }
    }
    showAllProducts() {
      this.$('[data-search]').value = ''; clearTimeout(this.searchTimer); this.fetchCatalog(1, '');
    }
    async search() {
      const query = this.$('[data-search]').value.trim(); clearTimeout(this.searchTimer);
      await this.fetchCatalog(1, query);
    }
    byHandle() {
      let handle = this.$('[data-handle]').value.trim();
      if (handle.includes('/')) { try { const url = new URL(handle, location.origin); handle = url.pathname.split('/products/')[1]?.split('/')[0] || ''; } catch { handle = ''; } }
      if (!/^[a-zA-Z0-9_-]+$/.test(handle)) { this.status('handle_error', true); return; }
      this.loadProduct(handle);
    }
    async loadProduct(handle) {
      this.searchAbort?.abort(); clearTimeout(this.searchTimer);
      this.productAbort?.abort(); this.productAbort = new AbortController(); const controller = this.productAbort;
      this.status('loading'); let product;
      try {
        try { product = await this.jsonResponse(this.resourceUrl('products/' + encodeURIComponent(handle) + '.js'), controller.signal); }
        catch (error) {
          if (error.name === 'AbortError') return;
          product = await this.sectionResponse('products/' + encodeURIComponent(handle), '[data-pc-product-result]', controller.signal);
        }
        if (!product?.id || product.handle !== handle || !Array.isArray(product.images)) throw new Error('invalid product response');
        if (!controller.signal.aborted && this.isConnected) this.setProduct(product, this.drafts?.[String(product.id)]?.config);
      } catch (error) { if (error.name !== 'AbortError') this.status('product_error', true); }
    }
    disconnectedCallback() { super.disconnectedCallback(); this.productAbort?.abort(); this.catalogAbort?.abort(); }
  }


  class Designer extends Base {
    init() {
      try { this.config = normalize(this.config, this.product); this.config.views = this.config.views.filter(v => v.enabled !== false && (v.types.logo || v.types.text)); if (!this.config.views.length) throw new Error('invalid_config'); }
      catch { this.config = null; this.status('invalid_config', true); this.$('[data-submit]').disabled = true; this.on(this.$('form'), 'submit', event => event.preventDefault()); return; }
      this.logoStates = new Map();
      this.textStates = new Map();
      this.textFont = this.textSettingsFor().font; this.textColor = this.textSettingsFor().color;
      this.$('[data-text-input]').maxLength = this.textSettingsFor().maxChars; this.$('[data-text-input]').value = this.$('[data-text-input]').value.slice(0, this.textSettingsFor().maxChars);
      this.$('[data-text-font]').value = this.textFont; this.$('[data-text-color]').value = this.textColor;
      this.on(this.$('[data-upload]'), 'change', async e => { const hadLogo = Boolean(this.logo); this.logoStates.clear(); this.uploadPending = true; this.$('[data-submit]').disabled = true; try { await this.upload(e.target); } finally { this.uploadPending = false; this.updateVariant(); } if (!hadLogo && this.logo && !this.textManuallyMoved) this.textState = null; this.rebuildText(); this.updateOrder(); });
      this.on(this.$('[data-text-input]'), 'input', () => { this.textStates.clear(); this.rebuildText(); });
      this.on(this.$('[data-text-font]'), 'change', e => { if (!this.textSettingsFor().allowFont) return; this.textFont = e.target.value; this.textStates.clear(); this.rebuildText(); });
      this.on(this.$('[data-text-color]'), 'input', e => { if (!this.textSettingsFor().allowColor) return; this.textColor = e.target.value; this.render(); });
      this.on(this.$('[data-text-size]'), 'input', e => { if (this.config.rules.resize) this.rebuildText(number(e.target.value)); });
      this.on(this.$('[data-text-rotation]'), 'input', e => { if (this.config.rules.rotate) this.rebuildText(null, number(e.target.value)); });
      this.on(this.$('[data-reset-text]'), 'click', () => { this.textState = null; this.textManuallyMoved = false; this.rebuildText(this.view().textWidth, 0); });
      this.on(this.$('[data-logo-size]'), 'input', e => {
        if (!this.logo || !this.config.rules.resize) return;
        const v = this.view(); const width = this.areaFor('logo').width * clamp(number(e.target.value, 50), 1, v.maxLogoWidth) / 100;
        this.logo = constrain(this.areaFor('logo'), { ...this.logo, width, height: width * v.imageWidth / v.imageHeight / this.logoRatio }, v.imageWidth / v.imageHeight); this.render();
      });
      this.on(this.$('[data-logo-rotation]'), 'input', e => {
        if (!this.logo || !this.config.rules.rotate) return;
        const v = this.view(); this.logo = constrain(this.areaFor('logo'), { ...this.logo, rotation: number(e.target.value) }, v.imageWidth / v.imageHeight); this.render();
      });
      this.on(this.$('[data-center]'), 'click', () => this.resetLogo());
      this.on(this.$('[data-preview]'), 'change', e => this.classList.toggle('cc-preview-mode', e.target.checked));
      this.on(this.$('[data-variant]'), 'change', () => this.updateVariant());
      this.on(this.$('form'), 'submit', e => {
        if (this.uploadPending) { e.preventDefault(); this.status('loading_logo'); return; }
        const upload = this.$('[data-upload]');
        const hasLogo = this.allowed('logo') && this.logo && upload.files?.length;
        const hasText = this.allowed('text') && this.textState && this.textValue;
        if ((!hasLogo && !hasText) || !this.currentVariant?.available) { e.preventDefault(); this.status('required_design', true); return; }
        this.updateOrder();
        if (this.dataset.demo === 'true') { e.preventDefault(); this.status('demo_order'); }
      });
      this.$('[data-size-control]').hidden = !this.config.rules.resize;
      this.$('[data-rotation-control]').hidden = !this.config.rules.rotate;
      this.$('[data-center]').hidden = !this.config.rules.move;
      this.$('[data-logo-group]').hidden = !this.allowed('logo');
      this.$('[data-logo-controls]').hidden = !this.allowed('logo');
      this.$('[data-text-group]').hidden = !this.allowed('text');
      this.$('[data-text-size-control]').hidden = !this.config.rules.resize;
      this.$('[data-text-rotation-control]').hidden = !this.config.rules.rotate;
      this.$('[data-font-control]').hidden = !this.textSettingsFor().allowFont;
      this.$('[data-color-control]').hidden = !this.textSettingsFor().allowColor;
      this.$('[data-reset-text]').hidden = !this.config.rules.move;
      this.logoElement.setAttribute('aria-disabled', String(!this.config.rules.move));
      this.textElement.setAttribute('aria-disabled', String(!this.config.rules.move));
      this.pointer(this.logoElement, () => this.logo && this.config.rules.move ? { ...this.logo } : null, (old, dx, dy) => {
        const v = this.view(); this.logo = constrain(this.areaFor('logo'), { ...old, x: old.x + dx, y: old.y + dy }, v.imageWidth / v.imageHeight); this.render();
      });
      this.on(this.logoElement, 'keydown', e => {
        if (!this.logo || !this.config.rules.move || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
        e.preventDefault(); const step = e.shiftKey ? 2 : .25; const v = this.view();
        this.logo = constrain(this.areaFor('logo'), { ...this.logo, x: this.logo.x + (e.key === 'ArrowLeft' ? -step : e.key === 'ArrowRight' ? step : 0), y: this.logo.y + (e.key === 'ArrowUp' ? -step : e.key === 'ArrowDown' ? step : 0) }, v.imageWidth / v.imageHeight); this.render();
      });
      this.pointer(this.textElement, () => this.textState && this.config.rules.move ? { ...this.textState } : null, (old, dx, dy) => {
        this.textManuallyMoved = true; const v = this.view(); this.textState = constrain(this.areaFor('text'), { ...old, x: old.x + dx, y: old.y + dy }, v.imageWidth / v.imageHeight); this.render();
      });
      this.on(this.textElement, 'keydown', e => {
        if (!this.textState || !this.config.rules.move || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
        e.preventDefault(); const step = e.shiftKey ? 2 : .25; const v = this.view();
        this.textManuallyMoved = true;
        this.textState = constrain(this.areaFor('text'), { ...this.textState, x: this.textState.x + (e.key === 'ArrowLeft' ? -step : e.key === 'ArrowRight' ? step : 0), y: this.textState.y + (e.key === 'ArrowUp' ? -step : e.key === 'ArrowDown' ? step : 0) }, v.imageWidth / v.imageHeight); this.render();
      });
      const select = this.$('[data-variant]');
      (this.product.variants || []).forEach(v => { const option = document.createElement('option'); option.value = v.id; option.textContent = `${v.title}${v.sku ? ` · ${v.sku}` : ''}${!v.available ? ` · ${this.t('sold_out')}` : ''}`; option.disabled = !v.available; select.append(option); });
      const available = this.product.variants?.find(v => v.available);
      const selected = this.dataset.variant;
      select.value = (this.product.variants?.find(v => String(v.id) === selected && v.available) || available)?.id || this.product.variants?.[0]?.id || '';
      this.updateVariant(); this.selectView(0);
    }
    selectView(index) {
      if (this.logo) this.logoStates.set(this.viewIndex, { ...this.logo });
      if (this.textState) this.textStates.set(this.viewIndex, { ...this.textState });
      this.viewIndex = index; const v = this.view();
      this.textFont = this.textSettingsFor().font; this.textColor = this.textSettingsFor().color;
      this.$('[data-text-input]').maxLength = this.textSettingsFor().maxChars; this.$('[data-text-input]').value = this.$('[data-text-input]').value.slice(0, this.textSettingsFor().maxChars);
      this.$('[data-text-font]').value = this.textFont; this.$('[data-text-color]').value = this.textColor;
      for (const selector of ['[data-logo-group]', '[data-logo-controls]']) this.$(selector).hidden = !this.allowed('logo');
      this.$('[data-text-group]').hidden = !this.allowed('text');
      this.$('[data-upload]').disabled = !this.allowed('logo'); this.$('[data-text-input]').disabled = !this.allowed('text');
      this.$('[data-font-control]').hidden = !this.textSettingsFor().allowFont; this.$('[data-color-control]').hidden = !this.textSettingsFor().allowColor;
      this.updateVariant();
      this.$('[data-logo-size]').max = v.maxLogoWidth;
      this.$('[data-text-size]').max = v.maxTextWidth;
      this.image.width = v.imageWidth; this.image.height = v.imageHeight; this.image.src = v.image;
      this.logo = this.logoStates.get(index) || null;
      this.textState = this.textStates.get(index) || null;
      if (!this.logo) this.resetLogo();
      this.rebuildText();
      this.renderTabs(); this.$('[data-view-title]').textContent = v.name; this.render();
    }
    rebuildText(width = null, rotation = null) {
      const v = this.view(); if (!v) return;
      const value = this.allowed('text') ? this.$('[data-text-input]').value.slice(0, this.textSettingsFor().maxChars) : '';
      const previous = this.textState;
      this.drawText(value, width ?? (previous ? previous.width / this.areaFor('text').width * 100 : v.textWidth), rotation ?? previous?.rotation ?? 0, previous);
    }
    imageLoaded() {
      super.imageLoaded();
      if (this.logo) { const v = this.view(); this.logo = constrain(this.areaFor('logo'), this.logo, v.imageWidth / v.imageHeight); this.render(); }
      this.rebuildText();
    }
    render() {
      super.render();
      if (!this.config) return;
      this.areaElement.hidden = true;
      for (const kind of ['logo', 'text']) {
        const guide = this.$('[data-customer-guide="' + kind + '"]'), area = this.areaFor(kind);
        if (!guide || !area) continue; guide.hidden = !this.allowed(kind);
        Object.assign(guide.style, { left: area.x + '%', top: area.y + '%', width: area.width + '%', height: area.height + '%' }); guide.dataset.shape = area.shape;
      }
      if (this.logo) {
        const v = this.view(); this.$('[data-logo-size]').value = this.logo.width / this.areaFor('logo').width * 100;
        this.$('[data-logo-rotation]').value = this.logo.rotation;
        this.$('[data-logo-measure]').textContent = `${round(this.logo.width / this.areaFor('logo').width * this.areaFor('logo').physicalWidthMm)} × ${round(this.logo.height / this.areaFor('logo').width * v.imageHeight / v.imageWidth * this.areaFor('logo').physicalWidthMm)} mm`;
      }
      if (this.textState) {
        const v = this.view(); this.$('[data-text-size]').value = this.textState.width / this.areaFor('text').width * 100;
        this.$('[data-text-rotation]').value = this.textState.rotation;
        this.$('[data-text-measure]').textContent = `${round(this.textState.width / this.areaFor('text').width * this.areaFor('text').physicalWidthMm)} mm`;
      }
      this.updateOrder();
    }
    updateVariant() {
      this.currentVariant = this.product.variants?.find(v => String(v.id) === this.$('[data-variant]').value);
      this.$('[data-submit]').disabled = this.uploadPending || !this.currentVariant?.available || (!this.allowed('logo') && !this.allowed('text'));
      if (this.currentVariant) this.$('[data-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'INR' }).format(this.currentVariant.price / 100);
    }
    updateOrder() {
      if (!this.config || !this.$('[data-placement]')) return;
      const v = this.view();
      this.$('[data-side-property]').value = v.name;
      const hasLogo = this.allowed('logo') && this.logo;
      const hasText = this.allowed('text') && this.textState;
      this.$('[data-text-font-property]').value = hasText ? this.textFont : '';
      this.$('[data-text-color-property]').value = hasText ? this.textColor : '';
      if (hasLogo) {
        const width = this.logo.width / this.areaFor('logo').width * this.areaFor('logo').physicalWidthMm;
        this.$('[data-size-property]').value = `${round(width)} mm`;
      } else { this.$('[data-size-property]').value = ''; }
      const position = state => state ? Object.fromEntries(Object.entries(state).map(([key, n]) => [key, round(n)])) : null;
      this.$('[data-placement]').value = hasLogo || hasText ? JSON.stringify({ version: 1, productId: this.config.productId, view: v, logo: hasLogo ? position(this.logo) : null, text: hasText ? { value: this.textValue, font: this.textFont, fontWeight: 600, color: this.textColor, position: position(this.textState) } : null, coordinates: 'percent_of_full_image', rotationUnit: 'degrees', sourceImagePixels: { width: v.imageWidth, height: v.imageHeight } }) : '';
    }
  }
  if (!customElements.get('pc-v9-setup')) customElements.define('pc-v9-setup', Setup);
  if (!customElements.get('pc-v9-designer')) customElements.define('pc-v9-designer', Designer);
})();





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() { const footerHeading =
    document.querySelectorAll('.footer-block--menu .footer-block__heading'); footerHeading.forEach(footerHeading => {
    footerHeading.addEventListener('click', function() { const parentItem = this.parentElement;
    parentItem.classList.toggle('active'); }); }); });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
